import React from 'react';
import { connect } from 'react-redux';
import OptionConflictModal from './OptionConflictModal';
import {
  toggleOption,
  toggleOptionConflictCancel,
  toggleOptionConflictResolve,
} from '../../store/actions';

const OptionConflictContainer = (props) => {
  const {
    dispatch,
    config,
    conflictConfig,
    conflictOption,
    modelInfo,
    basename,
  } = props;

  const onClose = () => {
    dispatch(toggleOptionConflictCancel());
  };

  const onSelect = (selection) => {
    dispatch(toggleOption(selection));
  };

  const onResolve = () => {
    dispatch(toggleOptionConflictResolve(conflictOption));
  };

  if (!conflictOption) {
    return null;
  }

  return (
    <OptionConflictModal
      option={conflictOption}
      previousConfig={config}
      conflictConfig={conflictConfig}
      hidePrice={false}
      onClose={onClose}
      onResolve={onResolve}
      onSelect={onSelect}
      modelInfo={modelInfo}
      basename={basename}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    config: state.config,
    conflictConfig: state.conflictConfig,
    conflictOption: state.conflictOption,
  };
};

export default connect(mapStateToProps)(OptionConflictContainer);
